import React from 'react'
import Navbar from '../components/Navbar/Navbar'
import Footer from '../components/Footer/Footer'
import CodeResultContainer from '../components/CodeResultContainer/CodeResultContainer'

function CodeResult() {
  return (
    <div>
        <Navbar/>
<CodeResultContainer/>
        <Footer/>
    </div>
  )
}

export default CodeResult